import React from 'react';
import PostModel from '../../models/PostModel.js';
import PostFields from '../PostFields.js';

export default (props) => {
	// config contains all the attributes of the base <latest-posts /> element
	const postModel = props.postModel;
	const widgetModel = props.widgetModel;
	const postIndex = props.postIndex;

	if (!(postModel instanceof PostModel)) {
		return '';
	}

	let title = postModel.getTitle();
	let content = postModel.getContent() || '';
	let url = postModel.getUrl();


	return (
		<div className={'post-' + postModel.id + ' post-item post-item-' + postIndex}>
			{title ? <div className="post-title">{url ? <PostFields.link href={url} text={title}/> : title}</div> : ''}
			{content ? (
				<span className="post-content" dangerouslySetInnerHTML={{ __html: content }}></span>
			) : ''}
			<PostFields.editLink postModel={postModel} widgetModel={widgetModel}></PostFields.editLink>
		</div>
	);
};
